import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer, { LocalStorageStratery } from 'vuex-shared-mutations'
import { Plugin } from 'vuex'
import { RootState } from './types'
import config from '@/config'

export const plugins: Plugin<RootState>[] = [
	createPersistedState({
		key: `navitel.shop_cart:${config.saleRegion}`,
		paths: ['userInfo', 'products', 'discount'],
		reducer: function(state) {
			return {
				userInfo: state.userInfo,
				products: state.products.filter((p: any) => p.id && p.count > 0), // remove bad products
				discount: state.discount,
			}
		},
	}),
	createMutationsSharer({
		predicate: [
			'addProduct',
			'deleteProduct',
			'setProductCount',
			'updateUserInfo',
			'setDiscount',
		],
		strategy: new LocalStorageStratery({
			key: `navitel.shop_cart.share:${config.saleRegion}`,
		}),
	}),
]
